import React from 'react';
import { NavLink } from 'react-router-dom';
import './SidebarLayout.css';

type SidebarItem = {
  label: string;
  to: string;
  end?: boolean;
};

interface SidebarLayoutProps {
  title: string;
  subtitle?: string;
  items: SidebarItem[];
  children: React.ReactNode;
}

const SidebarLayout: React.FC<SidebarLayoutProps> = ({ title, subtitle, items, children }) => {
  return (
    <div className="sidebar-layout">
      <aside className="sidebar-panel">
        <div className="sidebar-header">
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        <nav className="sidebar-nav">
          {items.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `sidebar-link${isActive ? ' active' : ''}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className="sidebar-content">{children}</main>
    </div>
  );
};

export default SidebarLayout;
